
'use strict';

$( function() {

    /*******************************************
     * Events
     *******************************************/

    /**
     * [event]
     * ページトップ押下
     *
     * @return void
     */
    $( '#pagetop' ).on( 'click', function () {
        $( 'html, body' ).animate( { scrollTop : 0 }, 700, 'easeInOutExpo' );
    } );


    /**
     * [event]
     * メニューボタン押下
     *
     * @return void
     */
    var $btn = $( '#c-menu-btn' );
    var $header = $( '#l-header' );
    var $navsp = $( '#p-nav-sp' );
    var timer = null;

    $btn.on( 'click', function () {

        if ( Number( $navsp.css( 'opacity' ) ) === 1 ) {

            $btn.removeClass( 'close' );
            $navsp.removeClass( 'show' );

            timer = setInterval( function() {

                if ( Number( $navsp.css( 'opacity' ) ) === 0 ) {

                    $header.removeClass( 'fixed' );
                    clearInterval( timer );
                }
            }, 50 );
        }

        if ( $navsp.css( 'height' ) === '0px' ) {

            $header.addClass( 'fixed' );
            $btn.addClass( 'close' );
            $navsp.addClass( 'show' );
        }
    } );


    /**
     * [event]
     * サブナビゲーション押下
     * お問い合わせジャンプ
     *
     * @return void
     */
    $( '#l-header__jump' ).on( 'click', function ( e ) {
        e.preventDefault();

        $( 'html, body' ).animate( {
            scrollTop : $( '#p-information' ).offset().top
        }, 700, 'easeInOutExpo' );
    } );


    /**
     * [event]
     * ウィンドウリサイズ
     *
     * @return void
     */
    $( window ).on( 'resize', function () {
        adjustProjectHeading();
    } );


    /**
     * [event]
     * 心臓血管センター
     * ムービー再生
     *
     * @return void
     */
    var $pMovie = $( '#p-movie' );

    if ( $pMovie.length > 0 ) {

        var $pMovieEntity = $( '#p-movie__entity' );
        var $pMovieStop = $( '#p-movie__stop' );

        $pMovie.on( 'click', function ( e ) {
            e.stopPropagation();

            $pMovieEntity.removeClass( 'u-none' );
            $pMovieStop.removeClass( 'u-none' );

            if ( $pMovie.hasClass( 'playing' ) ) {

                if ( $pMovieEntity.get(0).paused ) {
                    $pMovieEntity.get(0).play();
                }
                else {
                    $pMovieEntity.get(0).pause();
                }

                return;
            }

            $pMovie.addClass( 'playing' );
            $pMovieEntity.get(0).play();
        } );

        $pMovieStop.on( 'click', function( e ) {
            e.stopPropagation();

            $pMovieEntity.addClass( 'u-none' );
            $pMovieStop.addClass( 'u-none' );
            $pMovie.removeClass( 'playing' );

            $pMovieEntity.get(0).pause();
            $pMovieEntity.get(0).currentTime = 0;
        } );

        $pMovieEntity.get(0).addEventListener( 'ended', function() {
            $pMovieEntity.addClass( 'u-none' );
            $pMovieStop.addClass( 'u-none' );
            $pMovie.removeClass( 'playing' );
        } );
    }


    /**
     * [event]
     * 診療のご案内 - こんな症状はありますか
     * ボックス開閉
     *
     * @return void
     */
    var $boxHeader  = $( 'div.p-symptom-box__header' );
    var $boxContent = $( 'div.p-symptom-box__content' );
    var delay = 500;

    if ( $boxHeader.length > 0 ) {

        $boxHeader.on( 'click', function() {

            var $this = $( this );
            var $content = $this.next();

            if ( isPC() ) {
                return;
            }

            if ( $content.hasClass( 'animate' ) ) {
                return;
            }

            // 表示中
            if ( $this.hasClass( 'open' ) ) {

                $content.css( 'height', 'auto' );
                $content.addClass( 'close' );
                $content.addClass( 'animate' );

                setTimeout( function() {
                    $this.removeClass( 'open' );
                    $content.removeClass( 'animate' );
                }, delay );

                return;
            }

            // 非表示中
            $this.addClass( 'open' );
            $content.addClass( 'animate' );
            $content.removeClass( 'close' );

            var h = $content.outerHeight();
            $content.css( 'height', 0 );

            setTimeout( function() {
                $content.css( 'height', h );
            }, 1 );

            setTimeout( function() {
                $content.removeClass( 'animate' );
            }, delay );
        } );
    }


    /**
     * [event]
     * ウィンドウリサイズ
     */
    var timerResize = void(0);
    var currentWidth = fetchActualWidth();

    $( window ).on( 'resize', function() {

        // iOS Safariのスクロールで発生する
        // リサイズイベントであれば何もしない
        if ( currentWidth === fetchActualWidth() ) {
            return;
        }

        clearTimeout( timerResize );

        // 診療のご案内 - こんな症状はありますか
        // ボックス開閉の状態初期化
        timerResize = setTimeout( function() {
            $boxHeader.removeClass( 'open' );
            $boxContent.css( 'height', 'auto' );
            $boxContent.addClass( 'close' );
        }, 300 );
    } );


    /*******************************************
     * Functions
     *******************************************/

    /**
     * 閲覧デバイスのPC判定（画面幅基準）
     *
     * @return boolean
     */
    function isPC() {
        return fetchActualWidth() > 750;
    }


    /**
     * ブラウザ共通のwindow幅を取得
     *
     * @returns number
     */
    function fetchActualWidth() {
        return window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    }


    /**
     * ページ見出しの背景画像位置を
     * グローバルナビゲーションに合わせる
     *
     * @return void
     */
    function adjustProjectHeading() {

        if ( $pHeading.length < 1 ) {
            return;
        }

        if ( $header.css( 'position' ) === 'fixed' ) {
            $pHeading.css( 'margin-top', $header.height() );
            return;
        }

        var h = Number( $( '#p-nav-pc' ).height() + 1 ) * -1;
        $pHeading.css( 'margin-top', h );
    }

    var $pHeading = $( '#p-heading' );

    adjustProjectHeading();


    /**
     * プリロード
     *
     * @param {string} images[]
     * @return void
     */
    function preload( images ) {
        images.forEach( function( image ) {
            var $img = $( '<img>' ).attr( 'src', image );
            $img.addClass( 'u-none' );

            $img.on( 'load', function() {
                $( '#preload' ).append( $img );
            } );
        } );
    }

    var images = [
        '/assets/images/icon-arrow-up-green.jpg',
    ];

    preload( images );
} );



// WEBPACK FOOTER //
// ./src/js/main.js